import { dictionaryApi } from './dictionaryClient';
import { normalizePadachhed, type Padachhed } from './ashtadhyayiApi';

export type { Padachhed };

export type CreatePadachhedBody = {
  i: string;
  order: number;
  text: string;
  bibhakti: number;
  bachan: number;
  digits?: string | null;
};

export type UpdatePadachhedBody = Partial<Omit<CreatePadachhedBody, 'i'>>;

function isRecord(x: unknown): x is Record<string, unknown> {
  return x != null && typeof x === 'object' && !Array.isArray(x);
}

function unwrapEntityPayload(raw: unknown): unknown {
  if (isRecord(raw) && 'data' in raw) return raw.data;
  return raw;
}

function normalizeList(data: unknown): Padachhed[] {
  const rows =
    Array.isArray(data) ? data : isRecord(data) && Array.isArray(data.data) ? (data.data as unknown[]) : [];
  return rows
    .map(normalizePadachhed)
    .filter((x): x is Padachhed => x != null)
    .sort((a, b) => a.order - b.order);
}

export async function listPadachhed(itemKey?: string): Promise<Padachhed[]> {
  const params = itemKey?.trim() ? { i: itemKey.trim() } : undefined;
  const res = await dictionaryApi.get<unknown>('/ashtadhyayi-padachhed', { params });
  return normalizeList(res.data);
}

export async function getPadachhed(id: number): Promise<Padachhed> {
  const res = await dictionaryApi.get<unknown>(`/ashtadhyayi-padachhed/${id}`);
  const row = normalizePadachhed(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid padachhed response');
  return row;
}

export async function createPadachhed(body: CreatePadachhedBody): Promise<Padachhed> {
  const res = await dictionaryApi.post<unknown>('/ashtadhyayi-padachhed', body);
  const row = normalizePadachhed(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid padachhed response');
  return row;
}

export async function updatePadachhed(id: number, body: UpdatePadachhedBody): Promise<Padachhed> {
  const res = await dictionaryApi.patch<unknown>(`/ashtadhyayi-padachhed/${id}`, body);
  const row = normalizePadachhed(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid padachhed response');
  return row;
}

export async function deletePadachhed(id: number): Promise<void> {
  await dictionaryApi.delete(`/ashtadhyayi-padachhed/${id}`);
}
